export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-primary mb-2">Страница не найдена</h1>
        <p className="text-gray-500">Проверьте ссылку и попробуйте снова.</p>
      </div>
    </div>
  )
}
